import { useState } from "react"
import { IconShapesOutline18 as ShapesIcon } from "nucleo-ui-outline-18"

import {
	iconAttributes,
	mintlifyIconUrl,
} from "@productlane/lib/src/tiptap/extensions/mintlify/icon-html"
import { Button, Input } from "@productlane/ui"

import type {
	CustomBodyParams,
	SlashCommandCustomBodyElement,
	SlashCommandDefinition,
} from "../../types"
import { iconClassName } from "../../constants"

type IconCustomProps = CustomBodyParams & {
	icon?: string
}

function IconPreview({ name }: { name: string }) {
	const url = mintlifyIconUrl(name)
	const style = {
		"--pl-icon-size": "18px",
		...(url ? { "--pl-icon": `url("${url}")` } : {}),
	} as React.CSSProperties
	return (
		<span
			data-type="icon"
			data-icon={url ? name : undefined}
			className="pl-icon"
			style={style}
			aria-hidden="true"
		/>
	)
}

const IconBody: SlashCommandCustomBodyElement<IconCustomProps> = ({
	submit,
}) => {
	const [name, setName] = useState("")
	const onSubmit = () => {
		if (iconAttributes(name)) submit({ icon: name })
	}

	return (
		<div className="flex w-full flex-col gap-2">
			<p className="text-xs font-medium">Lucide icon name</p>
			<div className="flex w-full flex-row items-start gap-2">
				<div className="flex h-8 w-[18px] shrink-0 items-center">
					<IconPreview name={name} />
				</div>
				<Input
					name="icon-name"
					type="text"
					variant="outline"
					placeholder="rocket"
					value={name}
					onChange={(event) => setName(event.target.value)}
					onKeyDown={(event) => {
						if (event.key === "Enter") onSubmit()
					}}
					className="w-full bg-transparent text-xs outline-none"
					autoComplete="off"
					autoFocus
				/>
				<Button onClick={onSubmit} variant="default" className="w-min">
					Add
				</Button>
			</div>
		</div>
	)
}

export const iconCommand: SlashCommandDefinition<IconCustomProps> = {
	key: "icon",
	title: "Icon",
	icon: <ShapesIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range, customBodyParams }) => {
		const chain = editor.chain().focus().deleteRange(range)
		if (customBodyParams?.icon)
			chain.insertIcon({ icon: customBodyParams.icon })
		chain.run()
	},
	customBody: IconBody,
	group: "blocks",
	aliases: ["icon", "lucide", "symbol", "glyph"],
}
